import * as PoziUtils from 'api/utils'
import type { ConfigLayerCapabilityOptions } from 'config/catalog/ConfigLayerCapability'

export interface StyleGeoStylerOptions {
  url: string
  type: StyleGeoStylerType
}

export enum StyleGeoStylerType {
  SLD = 'SLD'
}

export class StyleGeoStyler {
  static getStyleGeoStyler (capabilityOptions: ConfigLayerCapabilityOptions, title: string) {
    const layerTitle = encodeURIComponent(title)

    const styleGeoStyler = capabilityOptions.styleGeoStyler

    // console.debug('getStyleGeoStyler', layerTitle, styleGeoStyler, capabilityOptions)

    let url = styleGeoStyler?.url

    if (!url) {
      // console.debug('getStyleGeoStyler - styleGeoStyler.url not provided. Trying to generate it.', capabilityOptions.titleid, title, capabilityOptions)

      // Create GetStyles URL from layer URL
      try {
        // Get layer URL without proxy for now. We'll add proxy below
        const layerUrl = PoziUtils.getLayerUrl(capabilityOptions, {}, false)

        const layerUrlObj = new URL(layerUrl)

        const params = layerUrlObj.searchParams

        // Make sure all params are upper case
        for (const [key, value] of params.entries()) {
          params.delete(key)

          const keyUC = key.toUpperCase()
          params.set(keyUC, value)
        }

        // Make it a GetStyles request
        params.set('REQUEST', 'GetStyles')

        // Update search params of URL
        layerUrlObj.search = params.toString()

        // console.debug('getStyleGeoStyler - styleGeoStyler.layerUrl', layerUrl, layerUrlObj.href)

        url = layerUrlObj.toString()
      } catch (error) {
        console.log('getStyleGeoStyler - error generating url', capabilityOptions.titleid, title, error)
      }
    }

    if (!url) {
      console.log('getStyleGeoStyler - styleGeoStyler.url not available.', capabilityOptions.titleid, title)
      return
    }

    // Prepend proxy URL if available and if not already part of the URL
    const proxyUrl = PoziUtils.getLayerProxyUrl(capabilityOptions)
    if (proxyUrl && !url.startsWith(proxyUrl)) {
      url = `${proxyUrl}${url}`
    }

    const type = styleGeoStyler?.type || StyleGeoStylerType.SLD
    switch (type) {
      case StyleGeoStylerType.SLD:
        return this.getSld(url, layerTitle)
      default:
        console.log('getStyleGeoStyler - styleGeoStyler.type is not valid: ', capabilityOptions.title, type)
    }
  }

  private static getSld (url: string, layerTitle: string) {
    const styleGeoStyler: StyleGeoStylerOptions = {
      url: `${url}&LAYERS=${layerTitle}&`,
      type: StyleGeoStylerType.SLD
    }

    // console.debug('StyleGeoStyler - getSld', styleGeoStyler)

    return styleGeoStyler
  }
}
